// MOD-17 Component Studio — prop tip seti + sınırlar (BE `ComponentPropTypes` /
// `ComponentConstraints` birebir aynası). Şema tasarımcısı Forms builder kopyası;
// tip listesi bilinçli olarak küçük ve kapalı tutulur (validasyon yüzeyi minimal).

/** Prop tipleri — BE `ComponentPropTypes.All` ile birebir aynı sıra. */
export const PROP_TYPES = ['text', 'textarea', 'number', 'boolean', 'select', 'image-url'] as const;

export type PropType = (typeof PROP_TYPES)[number];

export function isPropType(value: string): value is PropType {
  return (PROP_TYPES as readonly string[]).includes(value);
}

/** Yalnız `select` bir `options` listesi ister (BE `RequiresOptions`). */
export function propTypeRequiresOptions(type: PropType): boolean {
  return type === 'select';
}

/** BE `ComponentConstraints` birebir aynası — kaydetmeden önce inline uyarı üretir. */
export const COMPONENT_CONSTRAINTS = {
  maxFields: 50,
  maxNameLength: 200,
  maxCategoryLength: 80,
  maxKeyLength: 100,
  maxLabelLength: 200,
  maxOptionsPerField: 50,
  maxOptionLength: 200,
  maxTemplateLength: 100_000,
  maxDefaultStyleLength: 20_000,
} as const;
